import {BehaviorSubject, combineLatest, filter, switchMap} from 'rxjs';
import {BaseService} from '@esgi/core/service';
import {Test} from '../kit/tests-control/types';
import {V2PagesReportsStudentProgressController} from '@esgi/contracts/esgi';
import {UserInfo} from 'libs/core/src/authentication/current-user/types';
import {TestContentArea} from '@esgi/main/kits/common';
import {AvailableTestsRequest, SubjectInfo, SubjectTab, UnitDataSettings} from '../types';

export class TestService extends BaseService {
	public loaded$ = new BehaviorSubject(false);
	public tests$ = new BehaviorSubject<Test[]>([]);
	protected controller = new V2PagesReportsStudentProgressController();

	constructor(private user: UserInfo, private selectedSubject$: BehaviorSubject<SubjectTab>, private selectedStudents$: BehaviorSubject<UnitDataSettings>, private allSubjects$: BehaviorSubject<SubjectTab[]>) {
		super();

		this.completeOnDestroy(
			combineLatest([this.selectedSubject$, this.selectedStudents$, this.allSubjects$])
		).pipe(
			filter(([subject, students]) => {
				return subject !== null && students !== null && students?.students.length !== 0;
			}),
			switchMap(([subjects, students, allSubjects]) => {
				const subjectsModel: SubjectInfo[] = subjects.id === 0 ? allSubjects.filter(x => x.id !== 0).map(x => {
					return {
						subjectID: x.id,
						name: x.name,
						subjectType: x.type,
						subjectLevel: x.level,
					} as SubjectInfo;
				}) : [{
					subjectID: subjects.id,
					name: subjects.name,
					subjectType: subjects.type,
					subjectLevel: subjects.level,
				} as SubjectInfo];
				const availableTestsModel: AvailableTestsRequest = {
					subjects: subjectsModel,
					studentIDs: [...students.students.map((student) => student.id)],
				};
				return this.controller.availableTests(availableTestsModel);
			})
		).subscribe({
			next: (response) => {
				const flatSubjectTest: Test[] = response.value.subjectTests.flatMap((subjectTests) => {
					return subjectTests.tests.map((test) => {
						const testLocal: Test = {
							id: test.testID,
							name: test.name,
							contentArea: test.contentAreaName as TestContentArea,
							correct: test.correct,
							incorrect: test.incorrect,
							untested: test.untested,
							isTested: test.isTested,
							subjectID: subjectTests.subjectID,
							subjectName: allSubjects$.value.find(x => x.id === subjectTests.subjectID)?.name || '',
						};
						return testLocal;
					});
				});

				this.tests$.next(flatSubjectTest);
			},
			complete: () => {
				this.loaded$.next(true);
			},
		});
	}

	public override dispose() {
		super.dispose();
		this.controller.dispose();
	}
}
